module.exports = __webpack_public_path__ + "img/17@2x.01fe656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/17@2x.png
// module id = uAlT
// module chunks = 0